module.exports = __webpack_public_path__ + "img/house_04.56f3d921.jpg";